var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"am-hamburger",class:{
		'is-active': _vm.value
	},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('span',{staticClass:"am-hamburger__line am-hamburger__line--top"}),_c('span',{staticClass:"am-hamburger__line am-hamburger__line--mid"}),_c('span',{staticClass:"am-hamburger__line am-hamburger__line--bot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }